var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditConnectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.799,
    height: 22,
    viewBox: "0 0 23.799 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4524",
    "data-name": "Rectangle 4524",
    width: 23.799,
    height: 22,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11140",
    "data-name": "Group 11140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44605",
    "data-name": "Path 44605",
    d: "M4.871,6.948A14.716,14.716,0,0,0,6.114,10.31,20.933,20.933,0,0,0,9.369,15.2c.19.208.38.515.61.557s.5-.2.744-.326c.454-.24.9-.5,1.354-.737a1.308,1.308,0,0,1,1.844.51q.924,1.578,1.827,3.167a1.308,1.308,0,0,1-.578,1.893c-1.184.575-2.376,1.137-3.567,1.7a.47.47,0,0,1-.3.019,8.116,8.116,0,0,1-2.868-1.6,21.557,21.557,0,0,1-4.321-4.92A27.172,27.172,0,0,1,.618,8.186,12.683,12.683,0,0,1,0,4.347,11.91,11.91,0,0,1,.189,2.772a.49.49,0,0,1,.193-.29Q1.973,1.369,3.576.275A1.315,1.315,0,0,1,5.557.72q.909,1.558,1.8,3.124a1.319,1.319,0,0,1-.473,1.876c-.661.413-1.33.812-2.017,1.229",
    transform: "translate(0 -0.001)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44606",
    "data-name": "Path 44606",
    d: "M98.344,75.236c-.452-.6-.924-1.174-1.347-1.786a20.592,20.592,0,0,1-2.5-4.819.3.3,0,0,1,.157-.429c.5-.283.975-.6,1.476-.9l3.555,2.435,2.36,1.619a.637.637,0,0,0,.906,0l8.724-5.98c.075-.051.151-.1.263-.174a2.617,2.617,0,0,1,.032.28q0,5.467,0,10.934a.983.983,0,0,1-1.036,1.034q-3.25.008-6.5,0a.37.37,0,0,1-.261-.163c-.346-.575-.674-1.161-1.012-1.741a2.512,2.512,0,0,0-3.549-.989l-1.269.693",
    transform: "translate(-88.174 -60.853)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44607",
    "data-name": "Path 44607",
    d: "M134.575,60.017l-4.757-3.261c-.281-.192-.564-.381-.839-.581-.052-.038-.11-.14-.094-.189a2.592,2.592,0,0,0-.057-1.727h14.144l-8.4,5.758",
    transform: "translate(-120.251 -50.647)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditConnectIcon);
export default __webpack_public_path__ + "static/media/edit-connect-icon.5ffd7c99b4f9ae69e7ebe93ec3db76f7.svg";
export { ForwardRef as ReactComponent };